import { RecordList, findApiV4Link, ProjectTeaserWithTracking, useJsonApi } from 'shared'

export const Recommender = ({ apiUrl, sourceProjectId }) => {
  const { data: project } = useJsonApi(apiUrl)
  const apiUrl2 = project && findApiV4Link({ ofObject: project, withRel: 'recommended_projects_url' })
  const { data, loading } = useJsonApi(apiUrl2)
  const recommendedProjects = data && data.data || []

  const renderTeaser = (project, index) => <ProjectTeaserWithTracking
    project={project}
    index={index}
    trackingPath='/project-page/recommender'
    sourceProjectID={sourceProjectId}
    openInTab
    teaserTracking='ppp-project-recommendation'
  />
  return <div>
    <h2 className="text-3xl text-center mt-0 mb-4">{I18n.t('projects.show.recommender.headline')}</h2>
    <RecordList
      loading={loading}
      perPage={3}
      records={shuffle(recommendedProjects)}
      render={renderTeaser}
    />
  </div>
}

const shuffle = (array) => {
  for (let i = array.length; i; i--) {
    let j = Math.floor(Math.random() * i);
    [array[i - 1], array[j]] = [array[j], array[i - 1]]
  }
  return array
}
